<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0" *ngIf="!InProccessing">Deposit List</h5>
      <h5 class="card-title border-0 pb-0" *ngIf="InProccessing">Deposit List (Please wait...)</h5>
      <br />
      <br />
      <button *ngIf="!InProccessing" (click)="exportexcel_Funds_Charge()" type="button" class="btn btn-warning"
        style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Deposited Amount (IRR)</th>
              <th>Deposit Date</th>
              <th>Description</th>
              <th>Created By</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds_Charge
          | paginate
                  : {
                      id: 'DataList_UserTable_Charge',
                      itemsPerPage: 10,
                      currentPage: page_Charge,
                      totalItems: DataList_Funds_Charge.length
                    }
          ">
              <td>{{DataList_Funds_Charge.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.price | number}}</td>
              <td>{{item.price_date}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.username}}</td>
              <td>{{item.subdate}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <pagination-controls id="DataList_UserTable_Charge" nextLabel="Next" previousLabel="Previous"
        (pageChange)="page_Charge = $event"></pagination-controls>
    </div>
  </div>


  <div class="card card-statistics mb-30" style="margin-top: 10px;">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0" *ngIf="!InProccessing">Registered Expense List</h5>
      <h5 class="card-title border-0 pb-0" *ngIf="InProccessing">Registered Expense List (Please wait...)</h5>
      <br />
      <br />
      <button *ngIf="!InProccessing" (click)="exportexcel_Funds()" type="button" class="btn btn-warning"
        style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Customer Name</th>
              <th>Decree Number</th>
              <th>Expense Amount (IRR)</th>
              <th>Expense Date</th>
              <th>Expense Title</th>
              <th>Description</th>
              <th>Attachment</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds
            | paginate
                    : {
                        id: 'DataList_UserTable_Pay',
                        itemsPerPage: 10,
                        currentPage: page_Pay,
                        totalItems: DataList_Funds.length
                      }
            ">
              <td>{{DataList_Funds.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.code2}}</td>
              <td>{{item.price | number}}</td>
              <td>{{item.price_date}}</td>
              <td>{{item.title}}</td>
              <td>{{item.dsc}}</td>
              <td>
                <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Funds/{{item.src}}" *ngIf="item.src"><i
                    class="fa fa-download"></i> Download </a>
              </td>
              <td>
                <p *ngIf="item.status==0" style="color: #39539b;">Under Review</p>
                <p *ngIf="item.status==1" style="color: 489b39;">Approved</p>
                <p *ngIf="item.status==-1" style="color: crimson;">Rejected</p>
              </td>
              <td>{{item.subdate}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <pagination-controls id="DataList_UserTable_Pay" nextLabel="Next" previousLabel="Previous"
        (pageChange)="page_Pay = $event"></pagination-controls>

    </div>
  </div>



  <table id="excel-table-charge" style="display: none;">
    <thead>
      <tr>
        <th>#</th>
        <th>ID</th>
        <th>Deposited Amount (IRR)</th>
        <th>Deposit Date</th>
        <th>Description</th>
        <th>Created By</th>
        <th>Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of DataList_Funds_Charge">
        <td>{{DataList_Funds_Charge.indexOf(item)+1}}</td>
        <td>{{item.code}}</td>
        <td>{{item.price | number}}</td>
        <td>{{item.price_date}}</td>
        <td>{{item.dsc}}</td>
        <td>{{item.username}}</td>
        <td>{{item.subdate}}</td>
      </tr>
    </tbody>
  </table>


  <table id="excel-table" style="display: none;">
    <thead>
      <tr>
        <th>#</th>
        <th>ID</th>
        <th>Customer Name</th>
        <th>Decree Number</th>
        <th>Expense Amount (IRR)</th>
        <th>Expense Date</th>
        <th>Expense Title</th>
        <th>Description</th>
        <th>Status</th>
        <th>Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of DataList_Funds">
        <td>{{DataList_Funds.indexOf(item)+1}}</td>
        <td>{{item.code}}</td>
        <td>{{item.customer}}</td>
        <td>{{item.code2}}</td>
        <td>{{item.price | number}}</td>
        <td>{{item.price_date}}</td>
        <td>{{item.title}}</td>
        <td>{{item.dsc}}</td>
        <td>
          <p *ngIf="item.status==0" style="color: #39539b;">Under Review</p>
          <p *ngIf="item.status==1" style="color: 489b39;">Approved</p>
          <p *ngIf="item.status==-1" style="color: crimson;">Rejected</p>
        </td>
        <td>{{item.subdate}}</td>
      </tr>
    </tbody>
  </table>